/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// console.log('Hello World from Webpacker')
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import ReactOnRails from "react-on-rails";

import Root from "../components/containers/root";
import SubscriptionInfo from "../components/components/subscription_info";

require("enhancements/utilities");
require("enhancements/gonative");
require("enhancements/games");
require("enhancements/static_pages");
require("enhancements/subscriptions"); // set prices
require("enhancements/braintree"); // hosted fields

ReactOnRails.register({
  Root,
  SubscriptionInfo
}); // ES6 shorthand for {Hello: Hello}
